import { render, staticRenderFns } from "./CardShippingFeesPagesContainer.vue?vue&type=template&id=653c1a74&"
import script from "./CardShippingFeesPagesContainer.vue?vue&type=script&lang=js&"
export * from "./CardShippingFeesPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports